<template>
  <v-list dense>
    <v-list-group v-for="(venue) in meetings" :key="`${venue.track}+${venue.meeting_type}`"
      class="meetings-list mb-n2"
      :value="selectedMeetingList === `${venue.track}+${venue.meeting_type}`">
      <template v-slot:activator>
        <v-list-item-icon style="margin-right: 5px !important;">
          <img :src="image[venue.meeting_type]" style="max-width:20px; filter: invert(100%);" />
        </v-list-item-icon>
        <v-list-item-content>
          <strong><v-list-item-title class="subtitle-1">
            {{ venue.track }}</v-list-item-title></strong>
        </v-list-item-content>
      </template>
      <v-list-item v-for="date in uniqueDates(venue)" :key="date"  class="caption">
        <Date @select="handleDateClick"
          :summary="summary" :date="date" :races="races"
          :meeting="venue"/>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>

<script>
/* eslint-disable global-require */
import { mapActions, mapGetters, mapState } from 'vuex'
import Date from '../Date'

export default {
  name: 'Meeting',
  components: {
    Date
  },
  computed: {
    ...mapGetters(['getRaces', 'getSelectedRace']),
    ...mapState(['selectedMeeting', 'selectedRace', 'betsByType']),
    image () {
      return {
        HARNESS: require('@/assets/RaceType_Harness-BLACK.svg'),
        THOROUGHBRED: require('@/assets/RaceType_Gallops-BLACK.svg'),
        GREYHOUND: require('@/assets/RaceType_Greyhounds-BLACK.svg')
      }
    },
    races () {
      return this.getRaces || []
    },
    selectedMeetingList () {
      if (this.selectedMeeting) {
        return `${this.selectedMeeting.track}+${this.selectedMeeting.meeting_type}`
      } return null
    }
  },
  methods: {
    ...mapActions(['setSelectedMeeting', 'clearBetsByType', 'clearRaces', 'updateAllRaces', 'updateNoRacesAvail', 'fetchBetsByCustomer', 'setSelectedDate', 'fetchBets', 'fetchRaces', 'fetchBookieRace', 'fetchRacesDated', 'fetchBetsByType', 'fetchBookieBetsDated']),
    uniqueDates (venue) {
      const dates = []
      venue.meetings.forEach((current) => {
        if (dates.indexOf(current.meetingDate) === -1) {
          dates.push(current.meetingDate)
        }
      })
      dates.sort((a, b) => a.localeCompare(b))
      return dates
    },
    handleDateClick (date, meeting) {
      this.clearRaces([])
      this.clearBetsByType()
      this.setSelectedDate(date)
      this.$store.commit('clearRunners')
      this.setSelectedMeeting(meeting)
      this.fetchRacesDated()
      this.fetchBetsByType()
      this.updateDataTableHeight()
      this.updateAllRaces(false)
      this.updateNoRacesAvail(false)
      if (this.viewType === 'overView') {
        this.fetchBookieBetsDated()
        this.fetchBetsByCustomer()
        this.fetchBookieRace()
      }
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    meetings: {
      type: Array,
      default: () => []
    },
    racesLoading: {
      type: Boolean,
      default: false
    },
    summary: {
      type: Boolean,
      default: false
    },
    viewType: {
      type: String
    },
    updateDataTableHeight: {
      type: Function
    }
  }
}
</script>

<style scoped>
</style>
